export default __webpack_public_path__ + "media/color/xpm-3d3b2ae2.svg";